import { makeStyles, Theme } from '@material-ui/core/styles';

const maxCellWidth = '24rem';

export const useStyles = makeStyles((theme: Theme) => ({
  '@global': {
    '.MuiCheckbox-root.Mui-checked': {
      color: '#c4122f !important',
    },
    '.MuiInput-underline:after': {
      borderBottomColor: '#c4122f !important',
    },
    '.MuiInput-underline.Mui-focused:after': {
      borderBottomColor: '#c4122f !important',
    },
    '.MuiCircularProgress-root': {
      color: '#c4122f !important',
    },
    '.MuiCircularProgress-colorPrimary': {
      color: '#c4122f !important',
    },
    '.MuiCircularProgress-svg': {
      color: '#c4122f !important',
    },
    '.MuiLinearProgress-root': {
      backgroundColor: 'rgba(196, 18, 47, 0.3) !important',
    },
    '.MuiLinearProgress-bar': {
      backgroundColor: '#c4122f !important',
    },
    '.MuiLinearProgress-barColorPrimary': {
      backgroundColor: '#c4122f !important',
    },
    '.MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottomColor: '#c4122f !important',
    },
    '.MuiMenuItem-root.Mui-selected': {
      backgroundColor: '#c4122f !important',
      color: '#fff !important',
    },
    '.MuiMenuItem-root.Mui-selected:hover': {
      backgroundColor: '#a41129 !important',
    },
    '.MuiListItem-root.Mui-selected': {
      backgroundColor: '#c4122f !important',
      color: '#fff !important',
    },
    '.MuiListItem-root.Mui-selected:hover': {
      backgroundColor: '#a41129 !important',
    },
  },
  toolbar: {
    backgroundColor: theme.palette.grey[700],
    '& .MuiIconButton-root': {
      color: theme.palette.common.white,
    },
    '& .MuiIconButton-root.Mui-disabled': {
      color: 'rgba(255, 255, 255, 0.3)',
    },
    '& .MuiInput-underline': {
      color: theme.palette.common.white,
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: theme.palette.common.white,
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#c4122f',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottomColor: '#c4122f',
    },
    '& .MuiInputBase-formControl': {
      border: 'none',
      backgroundColor: 'transparent',
    },
    '& .MuiCheckbox-root.Mui-checked': {
      color: '#c4122f',
    },
  },
  row: {
    '&:nth-of-type(even)': {
      backgroundColor: theme.palette.grey[50],
    },
    '&.MuiTableRow-hover:hover': {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.dark,
    },
  },
  cell: {
    width: 'auto !important',
    maxWidth: maxCellWidth,
    fontFamily: 'Work Sans, Arial, sans-serif !important',
  },
  headerCell: {
    width: 'auto !important',
    maxWidth: maxCellWidth,
    '& .MuiTableCell-head': {
      padding: '16px !important',
    },
    '& th.MuiTableCell-root': {
      padding: '16px !important',
      fontFamily: 'Work Sans, Arial, sans-serif !important',
    },
    '& .MuiCheckbox-root': {
      color: theme.palette.common.white,
    },
  },
}));
